/* eslint-disable */
import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';
import { destandard, convertToFormData, removeNullFieldsFromJson } from '../utils/commonFunctions';
import { UI_REP_HOME_PAGE, API_RETAILER_HOME_PAGE, API_REP_HOME_PAGE, PRELOGIN_HOME_PAGE } from '../data/homePageTypes';

export const getHomePage = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_PENDING'});
  return irelandApi.get('/api/retailer/home_page')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: {data: response.data.data.attributes.carousel}});
    })
    .catch(() => {
    });
};

export const getRepHomePage = () => (dispatch) => {
  dispatch({type: 'GET_REP_HOMEPAGE_CAROUSELS_PENDING'});
  dispatch({type: 'GET_REP_HOMEPAGE_TILES_PENDING'});
  return irelandApi.get('/api/rep/home_page')
    .then((response) => {
      dispatch({type: 'GET_REP_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: {data: response.data.data.attributes.carousel}});
      dispatch({type: 'GET_REP_HOMEPAGE_TILES_FULFILLED', payLoad: {data: response.data.data.attributes.tiles}});
    })
    .catch(() => {
    });
};

export const getCarousels = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_PENDING'});
  return irelandApi.get('/api/admin/home_page_carousel/retailer_index')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_REJECTED', payLoad: error.data});
    });
};

export const updateCarousels = (payload) => {
  const data = {
    home_page_carousel: {...payload}
  };
  return irelandApi.patch('/api/admin/home_page_carousel/change_position', data)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousels has been saved successfully"/>);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (const p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={data[p]}/>);
        }
      }
    });
};

export const updateCarousel = (id, payLoad, homePageType) => {
  const formData = prepareCarousalPayload(payLoad, homePageType);

  return irelandApi.patch(`/api/admin/home_page_carousel/${id}`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been updated successfully"/>);
      history.push(`/admin/homepages/${homePageType}#carousel`);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (const p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={`${p} : ${data[p]}`}/>);
        }
      }
    });
};

export const createCarousel = (payLoad, homePageType) => {
  const formData = prepareCarousalPayload(payLoad, homePageType);

  return irelandApi.post('/api/admin/home_page_carousel', formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been created successfully"/>);
      history.push(`/admin/homepages/${homePageType}#carousel`);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (const p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={`${p} : ${data[p]}`}/>);
        }
      }
    });
};

export const deleteCarousel = id => (dispatch) => {
  dispatch({type: 'DELETE_CAROUSEL_PENDING'});
  return irelandApi.delete(`/api/admin/home_page_carousel/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been deleted successfully"/>);
      dispatch({type: 'DELETE_CAROUSEL_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete Carousel"/>);
      dispatch({type: 'DELETE_CAROUSEL_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const getCarousel = id => (dispatch) => {
  dispatch({type: 'GET_CAROUSEL_PENDING'});
  return irelandApi.get(`/api/admin/home_page_carousel/${id}`)
    .then((response) => {
      dispatch({type: 'GET_CAROUSEL_META_FULFILLED', payLoad: response.data.meta});
      if (parseInt(id)) {
        const data = destandard({
          ...response.data.data.attributes
        });
        data.permission_ids = {};
        data.permissions.map((perm) => {
          perm.children.map((child) => {
            if (child.checked) {
              const element = {};
              element.checked = true;
              data.permission_ids[child.id] = element;
            }
          });
        });
        if (data.button_link.match(/^\/articles\/\d+$/)) {
          const arr = data.button_link.split('/');
          data.button_article_link = arr[arr.length - 1];
        }
        store.dispatch(actions.load('deep.home_page_carousel', data));
        dispatch({type: 'GET_CAROUSEL_FULFILLED', payLoad: data});
      }
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning"
                               message={'Unable to get carousel.'}/>, {autoClose: 2000});
      dispatch({type: 'GET_CAROUSEL_REJECTED', payLoad: 'error'});
    });
};

export const getGroups = () => (dispatch) => {
  dispatch({ type: "GET_GROUPS_LIST_PENDING" });

  return irelandApi.get(`/api/admin/home_page_carousel/new`)
    .then((response) => {
      dispatch({ type: "GET_GROUPS_LIST_FULFILLED", payLoad: response.data.meta });
    })
    .catch((error) => {
      dispatch({ type: 'GET_GROUPS_LIST_REJECTED', payLoad: error.data })
    })
};

const prepareCarousalPayload = (payLoad, homePageType) => {
  let carousalData = removeNullFieldsFromJson(payLoad);
  const permissions = Object.keys(carousalData.permission_ids).filter(p => carousalData.permission_ids[p].checked);
  let newHomePageType;

  if (homePageType === UI_REP_HOME_PAGE) {
    newHomePageType = API_REP_HOME_PAGE;
  } else if (homePageType === PRELOGIN_HOME_PAGE) {
    newHomePageType = PRELOGIN_HOME_PAGE;
  } else {
    newHomePageType = API_RETAILER_HOME_PAGE;
  }

  carousalData = {
    ...payLoad,
    home_page_type: newHomePageType,
    group_ids: carousalData.group_ids.map(curr => curr.value) || [],
    permission_ids: permissions
  };

  if (carousalData.button_article_link > 0) {
    carousalData["button_link"] = "/article/" + carousalData.button_article_link;
  }

  delete carousalData.permissions;


  if (carousalData["group_ids"] && carousalData["group_ids"].length === 0) {
    carousalData["group_ids"] = [];
  }

  if (carousalData.image) {
    delete carousalData.image_uid;
  }

  if (carousalData.mobile_image) {
    delete carousalData.mobile_image_uid;
  }

  if (carousalData.mobile_image === '') {
    delete carousalData.mobile_image;
  }

  const formData = convertToFormData('home_page_carousel', carousalData);

  return formData;
};
